import React, { useState, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Alterar, Excluir, Visualizar } from '../../../../components/Acoes'
import { get, excluir } from '../../../../util/AcessoApi'
import { ACOES } from '../../../../util/Enums'
import { getUsuario } from '../../../../util/Configuracoes'
import { mostrarToast } from '../../../../components/Toasts'
import { mensagens } from '../../../../util/Utilitarios.js'

export default props => {
    const [data, setData] = useState([])
    const target = useRef(null)

    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-entrada-produto',
                columns: [
                    {
                        Header: 'Id',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Operação',
                        accessor: 'operacao_descricao',
                        html: item => <span className={'tag-' + (item.operacao_id === 1 ? 'entrada' : 'saida')}>{(item.operacao_id === 1 ? 'Entrada' : 'Saída')}</span>,
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        },
                        filtro: {
                            tipo: 'combo-simples',
                            idColuna: 'operacao_id',
                            tipo: 'operacao'
                        }
                    },
                    {
                        Header: 'Data',
                        accessor: 'data',
                        ordenamento: {
                            tipo: 'data',
                        }
                    }, {
                        Header: 'Data Inicial',
                        accessor: 'data_2',
                        visivel: false,
                        filtro: {
                            tipo: 'data_inicial',
                            idColuna: 'data_inicial'
                        }
                    }, {
                        Header: 'Data Final',
                        accessor: 'data_1',
                        ordenamento: {
                            tipo: 'data',
                        },
                        visivel: false,
                        filtro: {
                            tipo: 'data_final',
                            idColuna: 'data_final'
                        }
                    }, {
                        Header: 'Cód.',
                        accessor: 'produto_id',
                        ordenamento: {
                            tipo: 'numero'
                        }
                    }, {
                        Header: 'Cód. Barras',
                        accessor: 'codigo_barras',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    }, {
                        Header: 'Produto',
                        accessor: 'descricao',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'produto_id',
                            tipo: 'produto'
                        }
                    }, {
                        Header: 'Qtde',
                        accessor: 'quantidade',
                        ordenamento: {
                            tipo: 'numero'
                        }
                    }, {
                        Header: 'Fornecedor/Responsável',
                        accessor: 'responsavel',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'responsavel_id',
                            tipo: 'fornecedor'
                        }
                    }, {
                        Header: 'Cliente',
                        accessor: 'cliente',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'cliente_id',
                            tipo: 'cliente'
                        }
                    }, {
                        Header: 'Tipo Produto',
                        accessor: 'tipo_produto',
                        visivel: false,
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'produto_tipo_id',
                            tipo: 'tipo_produto'
                        }
                    }, {
                        Header: 'Data Registro',
                        accessor: 'data_registro',
                        ordenamento: {
                            tipo: 'data'
                        }
                    }
                ]
            }
        ],
        []
    )

    const exclusao = propsAcao => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: props.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/estoque/produtoentradasaida', propsAcao.id,
                    () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    })
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const retornarCaminhoBase = item => item.operacao_id === 1 ? '/estoque/produtoentrada' : '/estoque/produtosaida'

    const acoesObj = [
        (propsAcao) => <Visualizar to={'/estoque/produtoentradasaida' + '/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={retornarCaminhoBase(propsAcao.row) + '/alteracao/' + propsAcao.id} />,
        (propsAcao) => <Excluir to={'/estoque/produtoentrada/consulta/'} action={() => exclusao(propsAcao)} />
    ]

    const botoes = [
        {
            titulo: ' Entrada',
            url: '/estoque/produtoentrada/cadastro',
            icone: 'icon-Add-Cart'
        }, {
            titulo: ' Saída',
            url: '/estoque/produtosaida/cadastro',
            icone: 'icon-Remove-Cart'
        }
    ]

    return (<div>
        <DataGridAlternativa ref={target} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/estoque/produtoentradasaida' modulo={props.modulo} titulo={'Consulta Entrada/Saída de Produto'}
            tituloLista={'Lista Entrada/Saída de Produtos'}
            botoesHeader={botoes} acoesObj={acoesObj} urlAlteracao={(propsUrl) => `/estoque/produtoentrada/${propsUrl.id}`} icone={'icon-File-ClipboardFileText'} caminhoConsultaFiltros='/estoque/produtoentradasaidapaginacao' />
    </div>)
}